import React from 'react';
import { ReactComponent as FreelancersIcon } from './freelancers.svg';
import { ReactComponent as WebHostingIcon } from './web-hosting.svg';

export default {
	title: 'The hybrid platform to buy, sell, or host',
	leftColumn: {
		title: 'Hire Talent',
		icon: FreelancersIcon,
		description: 'Find the right freelancers today.',
		ctas: [
			{
				type: 'primary',
				label: 'Search skills',
				link: '/marketplace',
				internal: false,
			},
			{
				type: 'secondary',
				label: 'Become a Seller',
				link: 'https://www.69work.com/sell',
				internal: false,
			},
		],
	},
	rightColumn: {
		title: 'Web Hosting',
		icon: WebHostingIcon,
		description: 'Managed VPS and WordPress hosting.',
		ctas: [
			{
				type: 'primary',
				label: 'Plans and pricing',
				link: 'https://cloud.69work.com',
				internal: false,
			},
			{
				type: 'secondary',
				label: 'Client login',
				link: 'https://cloud.69work.com/hosting/login',
				internal: true,
			},
		],
	},
};
